<div class="dropdown topbar-head-dropdown agency-context-selector" ngbDropdown #dropdown="ngbDropdown"
  placement="bottom-end" (openChange)="onOpenChange($event)">
  <button type="button" class="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle"
    [class.is-active]="isActive" [disabled]="switching" ngbDropdownToggle
    [attr.aria-label]="'t-agency-context-title' | translate"
    [ngbTooltip]="isActive ? ('t-agency-context-active' | translate: { value: activeName }) : ('t-agency-context-title' | translate)"
    placement="bottom" container="body">
    <i class="ri-store-2-line fs-22"></i>
    <!-- Agência ativa: tem de se ver de relance que os dados estão filtrados. -->
    <span class="position-absolute topbar-badge translate-middle badge rounded-pill bg-primary agency-context-dot"
      *ngIf="isActive"></span>
  </button>

  <div class="dropdown-menu dropdown-menu-end p-0 agency-context-menu" ngbDropdownMenu>
    <div class="px-3 pt-3 pb-2 border-bottom">
      <h6 class="m-0 fs-14 fw-semibold">{{ 't-agency-context-title' | translate }}</h6>
      <p class="text-muted fs-12 mb-2 text-truncate" *ngIf="isActive">
        {{ 't-agency-context-active' | translate: { value: activeName } }}
      </p>
      <input #searchInput type="text" class="form-control form-control-sm mt-2" [value]="search"
        [placeholder]="'t-agency-context-search' | translate" (input)="search = $any($event.target).value"
        (keydown.enter)="selectFirst(dropdown)" />
    </div>

    <div class="agency-context-list py-1">
      <button type="button" class="dropdown-item d-flex align-items-center gap-2"
        *ngFor="let option of filteredOptions" [class.active]="option.id === selectedId"
        (click)="choose(option.id, dropdown)">
        <i class="ri-check-line" [class.invisible]="option.id !== selectedId"></i>
        <span class="text-truncate">{{ option.name }}</span>
      </button>
    </div>
  </div>
</div>
